import styled from 'styled-components';

export const SInputGroup = styled.section<{}>(({ theme }) => {
  return `
    display: flex;
    flex-direction: column;
    position: relative;
  `;
});

export const SInputGroupInner = styled.section<{ gaps: number; disabled: boolean }>(({ theme, gaps, disabled }) => {
  return `
    display: flex;
    flex-direction: column;
    // -webkit-text-fill-color: ${disabled ? '' : theme.colors.black};
    opacity: ${disabled ? '0.5' : ''};
    .inputInGroup:not(:nth-last-child(-n+${1 + gaps})) {
      margin-bottom: ${theme.spacing.large}px;
    }
    @media only screen and (min-width: 800px) {
      flex-direction: row;
      justify-content: space-between;
      .inputInGroup:not(:nth-last-child(-n+${1 + gaps})) {
        margin-bottom: 0;
        margin-right: 3%;
      }
    }
  `;
});

export const SInputGap = styled.div(() => ({
  flexGrow: 1,
  flexShrink: 1,
  flexBasis: 0,
}));
export const SInputGroupTitle = styled.div`
  display: flex;
  align-items: center;
`;
export const STooltipWrapper = styled.div`
  margin-left: 5px;
`;

export const SErrorMessage = styled.span<{ initErrorSpacing?: boolean }>(({ initErrorSpacing, theme }) => ({
  fontSize: theme.font.size.smaller,
  fontWeight: theme.font.weight.light,
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.47',
  letterSpacing: 'normal',
  textAlign: 'left',
  marginTop: '5px',
  height: `${initErrorSpacing ? '18px' : '22px'}`,
  color: theme.colors.error,
}));
